var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"hidden",attrs:{"tabindex":"0"},on:{"focus":_vm.focusLast}}),_c('div',{ref:"first",staticClass:"hidden",attrs:{"tabindex":"-1"}}),_vm._t("default"),_c('div',{ref:"last",staticClass:"hidden",attrs:{"tabindex":"-1"}}),_c('div',{staticClass:"hidden",attrs:{"tabindex":"0"},on:{"focus":_vm.focusFirst}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }